import React from "react";
import ProductionsContent from "../ProductionsContent";
import Footer from "../Footer";

function Productions() {
  return (
    <div className="page-wrapper">
      <ProductionsContent />
      <br></br>
      <Footer />
    </div>
  );
}

export default Productions;
